import React from 'react';
import { StringProperty } from './types';

type Props = {
  property: StringProperty;
};

export function StringPropertyValue({ property }: Props) {
  const { value = null, unit = null } = property;

  if (value === null) {
    return null;
  }

  if (unit === null) {
    return <>{value}</>;
  }

  return <>{`${value}\u00A0${unit}`}</>;
}
